<template>
  <div class="md:max-w-xl md:m-auto md:mt-32 p-6">
    <div class="mb-8">
      <svg
        width="220"
        height="220"
        viewBox="0 0 220 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="110"
          cy="110"
          r="110"
          fill="#F6F6F6"
        />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="220"
          height="220"
        >
          <circle
            cx="110"
            cy="110"
            r="110"
            fill="black"
          />
        </mask>
        <g mask="url(#mask0)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.6638 86C22.7751 86 15.9537 90.5717 12.702
            97.2115C7.66083 95.0031 2.09145 93.7778 -3.76398
            93.7778C-15.2027 93.7778 -25.5499 98.454 -32.9996
            106H70.0002C68.0888 99.5745 62.1394 94.8889 55.0961
            94.8889C52.6379 94.8889 50.3129 95.4596 48.2463 96.4759C44.8627
            90.2364 38.2577 86 30.6638 86Z"
            fill="white"
          />
          <circle
            cx="28"
            cy="151"
            r="63"
            fill="#FF6600"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M51.5948 159.008C97.9794 134.487 134.326 112.234 132.777
            109.305C131.229 106.375 92.3711 123.878 45.9866
            148.399C-0.397968 172.919 -36.7446 195.172 -35.1959
            198.102C-33.6473 201.031 5.21029 183.528 51.5948
            159.008ZM46.6474 149.649C82.1037 130.905 111.319 116.604
            111.903 117.707C112.486 118.81 84.2153 134.899 48.759
            153.643C13.3026 172.387 -15.9131 186.687 -16.4962
            185.584C-17.0793 184.481 11.191 168.392 46.6474 149.649Z"
            fill="white"
          />
          <circle
            cx="163"
            cy="59"
            r="25"
            fill="black"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M185 134.5C192.456 134.5 198.5 128.456 198.5 121C198.5 128.456
          204.544 134.5 212 134.5C204.544 134.5 198.5 140.544 198.5
          148C198.5 140.544 192.456 134.5 185 134.5Z"
          fill="#C4C4C4"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M57 58.5C64.4558 58.5 70.5 52.4558 70.5 45C70.5 52.4558
          76.5442 58.5 84 58.5C76.5442 58.5 70.5 64.5442 70.5 72C70.5
          64.5442 64.4558 58.5 57 58.5Z"
          fill="black"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M102 163.5C107.247 163.5 111.5 159.247 111.5 154C111.5 159.247
          115.753 163.5 121 163.5C115.753 163.5 111.5 167.753 111.5
          173C111.5 167.753 107.247 163.5 102 163.5Z"
          fill="#C4C4C4"
        />
      </svg>
    </div>
    <div class="md:max-w-xs md:mb-14 mb-8">
      <BaseTitle class="mb-4">
        This page is lost in space!
      </BaseTitle>
      <BaseParagraph class="text-grey">
        We can't find what you're looking for, but the links below may help.
      </BaseParagraph>
    </div>
    <div class="md:flex md:justify-between">
      <BaseParagraph class="mb-14 mr-14">
        Your investments and documents
        <br>
        <br>
        <router-link
          class="text-orange"
          to="/"
        >
          Go to Kerala Club Login
        </router-link>
      </BaseParagraph>
      <BaseParagraph class="mb-14 mr-14">
        News and infos about Kerala and its team
        <br>
        <br>
        <a
          class="text-orange"
          href="https://www.kerala.vc"
        >
          Visit our website
        </a>
      </BaseParagraph>
      <BaseParagraph class="mb-14">
        First20, Stars recruiting stars
        <br>
        <br>
        <a
          class="text-orange"
          href="https://www.first20.club"
        >
          Register to First20
        </a>
      </BaseParagraph>
    </div>
  </div>
</template>

<script>
import BaseTitle from '../components/BaseTitle.vue';
import BaseParagraph from '../components/BaseParagraph.vue';

export default {
  name: 'PageNotFound',
  components: {
    BaseTitle,
    BaseParagraph,
  },
};
</script>
